<template>
  <t-default-entry
    sub-heading="Sign up"
    heading="新規お申し込み"
    :navigation-items="navigationItems"
    :class="componentClassName"
  >
    <div v-if="show_form" class="t-application-invite-user__instruction">
      <a-text>
        お申し込みには下記の書類が必要です。<br />
        ご準備いただき、規約に同意した上でお手続きを進めてください。
      </a-text>

      <!-- New SignUp -->
      <div class="t-application-invite-user__box t-application-invite-user__box--individual">
        <h3 class="t-application-invite-user__box-title">
          <a-icon icon="user" />
          個人名義でお申し込みの場合
        </h3>
        <ul class="t-application-invite-user__box-list">
          <li class="t-application-invite-user__box-item">
            お申込者様の本人確認書類<br />以下の書類から2点<br />　運転免許証<br />　マイナンバーカード<br />　運転経歴証明書<br />　印鑑登録証明書<br />　戸籍の附票<br />　住民票
            <div class="t-application-invite-user__box-detail">
              <div class="t-application-invite-user__remark">
                <a-caption-list>
                  <li>運転免許証、マイナンバーカードのいずれかは必須となります。</li>
                </a-caption-list>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="t-application-invite-user__box t-application-invite-user__box--coporation">
        <h3 class="t-application-invite-user__box-title">
          <a-icon icon="building" />
          法人名義でお申し込みの場合
        </h3>
        <ul class="t-application-invite-user__box-list">
          <li class="t-application-invite-user__box-item">
            登記事項証明書（登記簿謄本）
            <div class="t-application-invite-user__box-detail">
              <p>以下の項目を確認します。</p>
              <ul>
                <li>① 法人の名称</li>
                <li>② 本店または主たる事務所の所在地</li>
                <li>③ 事業内容</li>
                <li>④ 実質的支配者の有無</li>
                <li>⑤ 実質的支配者の氏名・住所・生年月日・顧客との関係</li>
              </ul>
              <div class="t-application-invite-user__remark">
                <a-caption-list>
                  <li>
                    実質的支配者については
                    <a-button
                      id="ownerLink"
                      variant="text"
                      color="primary"
                      target="_blank"
                      :href="authFailUrl"
                      title="別ウインドウにてPDF文書が表示されます。"
                      >こちら(573KB)</a-button
                    ><img src="/public/PDF_32.png" />
                  </li>
                </a-caption-list>
              </div>
            </div>
          </li>
          <li class="t-application-invite-user__box-item">お申し込み者様の運転免許証、またはマイナンバーカード</li>
          <li class="t-application-invite-user__box-item">
            <!--  eslint-disable-next-line prettier/prettier -->
            委任状（<a-button id="powerOfAttorneyLink" variant="text" color="primary" target="_blank" :href="authFailUrl2" title="別ウインドウにてPDF文書が表示されます。">様式例を確認(573KB)</a-button
            ><img src="/public/PDF_32.png" />）
            <div class="t-application-invite-user__box-detail">
              <div class="t-application-invite-user__remark">
                <a-caption-list>
                  <li>お申し込み者様が会社役員の場合は不要です。</li>
                </a-caption-list>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="t-application-invite-user__remark">
        <a-caption-list>
          <li>有効期限の記載がない書類は６ヶ月以内に作成されたものをご用意ください。</li>
          <li>
            申し込みステップは
            <a-button id="applicationStepLink" variant="text" color="primary" target="_blank" :href="authFailUrl3"
              >こちら</a-button
            >
          </li>
        </a-caption-list>
      </div>
      <!-- End New SignUp -->
    </div>

    <form class="t-application-invite-user__form" @submit.prevent="handleSubmitForm">
      <a-checkbox id="kiyaku" v-model="agree" label="" :disabled="!kiyakuView">
        <a-button
          id="contractTermsLink"
          variant="text"
          color="primary"
          target="_blank"
          :href="kiyakuUrl"
          title="別ウインドウにてPDF文書が表示されます。"
          @click="kiyakuClick()"
        >
          契約約款および重要事項説明(1641KB)
        </a-button>
        <img src="/public/PDF_32.png" class="t-application-invite-user__icon-margin" />
        に同意する
      </a-checkbox>
      <a-caption-list><li>「契約約款および重要事項説明」をお読みいただくとチェックできます。</li></a-caption-list>
      <a-checkbox id="kiyaku2" v-model="agree2" label="">
        <a-button id="contractTermsLink2" variant="text" color="primary" target="_blank" :href="kiyakuUrl2">
          NTTコミュニケーションズのプライバシーポリシー
        </a-button>
        に同意する
      </a-checkbox>
      <a-checkbox id="permitRec" v-model="agreeRec" label="">
        本サービス利用時のすべての通話の録音を承諾する
      </a-checkbox>
      <br />
      <a-caption-list
        ><li>上のチェックをすべて入れていただくとお申し込みボタンが押せるようになります。</li>
      </a-caption-list>

      <m-button-container class="t-application-invite-user__buttons">
        <a-button
          id="individual"
          variant="block"
          color="primary"
          :disabled="!agree || !agree2 || !agreeRec"
          @click="showModal('individual')"
        >
          個人名義のお申し込み
        </a-button>
        <a-button
          id="company"
          variant="block"
          color="primary"
          :disabled="!agree || !agree2 || !agreeRec"
          @click="showModal('company')"
        >
          法人名義のお申し込み
        </a-button>
        <a-button id="back" color="primary" @click="handleCancelClick">戻る</a-button>
      </m-button-container>
      <teleport to="body">
        <o-modal
          id="applicationInviteUser_showModal"
          v-model:visible="showModalDialog"
          class="o-modal-application-invite-user"
          footer-variant="confirmation"
          width="442px"
          :footer-shadow="true"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
        >
          <template #title>必要書類の確認</template>
          <div class="t-application-invite-user__box-detail">
            <p>必要書類は準備しましたか？ よろしければ申し込みにお進みください。</p>
            <div class="t-application-invite-user__box t-application-invite-user__box--individual">
              <h3 class="t-application-invite-user__box-title">
                <a-icon icon="user" />
                個人名義でお申し込みの場合
              </h3>
              <ul class="t-application-invite-user__box-list">
                <li class="t-application-invite-user__box-item">
                  お申込者様の本人確認書類<br />以下の書類から2点<br />　運転免許証<br />　マイナンバーカード<br />　運転経歴証明書<br />　印鑑登録証明書<br />　戸籍の附票<br />　住民票
                  <div class="t-application-invite-user__box-detail">
                    <div class="t-application-invite-user__remark">
                      <a-caption-list>
                        <li>運転免許証、マイナンバーカードのいずれかは必須となります。</li>
                      </a-caption-list>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="t-application-invite-user__box t-application-invite-user__box--coporation">
              <h3 class="t-application-invite-user__box-title">
                <a-icon icon="building" />
                法人名義でお申し込みの場合
              </h3>
              <ul class="t-application-invite-user__box-list">
                <li class="t-application-invite-user__box-item">登記事項証明書（登記簿謄本）</li>
                <li class="t-application-invite-user__box-item">
                  お申し込み者様の運転免許証、またはマイナンバーカード
                </li>
                <li class="t-application-invite-user__box-item">委任状（お申し込み者様が会社役員の場合は不要）</li>
              </ul>
            </div>
          </div>

          <!-- eslint-enable -->
          <template #footer>
            <a-button
              id="back"
              variant="outlined"
              color="primary"
              label="戻る"
              size="small"
              @click="showModalDialog = false"
            />
            <a-button
              id="next"
              variant="block"
              color="primary"
              submit="submit"
              label="申し込みに進む"
              size="small"
              @click="handleSubmitForm"
            />
          </template>
        </o-modal>
      </teleport>
    </form>

    <teleport to="body">
      <o-modal
        id="applicationInviteUser_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button id="ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-modal>
    </teleport>
  </t-default-entry>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TDefaultEntry from '@/components/templates/default-entry';
import AIcon from '@/components/atoms/icon';
import AButton from '@/components/atoms/button';
import ACheckbox from '@/components/atoms/checkbox';
import AText from '@/components/atoms/text';
import ACaptionList from '@/components/atoms/caption-list';
import MButtonContainer from '@/components/molecules/button-container';
import Simplebar from 'simplebar';
import OModal from '@/components/organisms/modal';
import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';
import { LP_URL } from '@/libs/constants';
import { utils } from '@/common/utils.js';

export default {
  name: 't-application-invite-user',
  components: {
    TDefaultEntry,
    AIcon,
    AButton,
    ACheckbox,
    AText,
    ACaptionList,
    MButtonContainer,
    OModal,
  },
  mixins: [messageContent, customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    // authFailUrl: {
    //   type: String,
    //   default: '#',
    // },
    priceList: {
      type: Array,
      default: new Array(0),
    },
    individualList: {
      type: Array,
      default: new Array(0),
    },
    coporationList: {
      type: Array,
      default: new Array(0),
    },
    // terms: {
    //   type: String,
    //   default: '',
    // },
    navigationItems: {
      type: Array,
      default: new Array(0),
    },
    handleProceedClick: {
      type: Function,
      default: () => {},
    },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      agree: false,
      agree2: false,
      agreeRec: false,
      showModalDialog: false,
      kiyakuUrl:
        'https://www.ntt.com/content/dam/nttcom/hq/jp/business/services/voice-visual-communication/callcenter-ivr/ccaas/pdf/kiyaku.pdf#toolbar=0',
      authFailUrl:
        'https://www.ntt.com/content/dam/nttcom/hq/jp/business/services/voice-visual-communication/callcenter-ivr/ccaas/pdf/for_business_hansyuhou.pdf#toolbar=0',
      authFailUrl2:
        'https://www.ntt.com/content/dam/nttcom/hq/jp/business/services/voice-visual-communication/callcenter-ivr/ccaas/pdf/for_business_hansyuhou.pdf#page=2&toolbar=0',
      authFailUrl3:
        'https://www.ntt.com/business/services/voice-visual-communication/callcenter-ivr/ccaas/lp/03_da.html#anchor2',
      campaignUrl: '/public/campaign.pdf#toolbar=0',
      kiyakuUrl2:
        'https://www.ntt.com/about-us/hp/privacy.html?elqTrackId=0c8d50a4b4b2443c9cab8fd4438cc151&elqaid=778&elqat=2&_ga=2.11629171.655034696.1641532286-717115474.1641532286',
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      businessType: '',
      kiyakuView: false,
      show_form: false,
      trialMigrationFlag: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-application-invite-user');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  created() {
    window.addEventListener('message', this.messageEventHandler);
  },
  mounted() {
    document.title = '新規お申し込み | COTOHA Call Center';
    this.show_form = true;
    utils.setMetaDescription(this.$route);
  },
  methods: {
    async handleSubmitForm(e) {
      e.preventDefault();
      /* this.handleProceedClick(this.agree); */

      const isLogin = await this.postRequest('/sessioncheck').catch(err => {
        console.log(err);
      });
      const createTmpData = {
        trialMigrationFlag: isLogin.session ? this.trialMigrationFlag : false,
        businessType: this.businessType,
      };
      this.postRequest('/signup/createtmpdata', createTmpData)
        .then(async e => {
          if (e.session) {
            if (e.status === 'failed') {
              this.showErrorModal(messageContent.requireTry('新規お申し込み'));
            } else {
              await this.setCookie('tmpUUID', e.tmpUUID, 'tmpYMD', e.tmpYMD);

              const tmpData = {
                businessType: this.businessType,
              };

              this.postRequest('/signup/updateBusinessType', {
                tmpCompanyID: e.tmpUUID,
                tmpYMD: e.tmpYMD,
                validate: false,
                data: tmpData,
              })
                .then(e => {
                  if (e.session) {
                    if (e.status === 'failed') {
                      this.showErrorModal(messageContent.requireTry('新規お申し込み'));
                    } else {
                      this.$router.push({ path: '/signup/form' });
                    }
                  } else {
                    window.location.href = '/login';
                  }
                })
                .catch(err => {
                  console.log(err);
                  this.showErrorModal(messageContent.requireTry('新規お申し込み'));
                });
            }
          } else {
            window.location.href = '/login';
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('新規お申し込み'));
        });
    },
    setCookie: async function (key, value, key2, value2) {
      await this.postRequest('/signup/setCookie', { key: key, value: value, key2: key2, value2: value2 })
        .then(e => {
          if (e.session) {
            if (e.status === 'failed') {
              this.showErrorModal(messageContent.requireTry('新規お申し込み'));
            }
          } else {
            window.location.href = '/';
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('新規お申し込み'));
        });
    },
    handleCancelClick() {
      window.location.href = LP_URL;
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showModal(type) {
      this.businessType = type;
      this.showModalDialog = true;
    },
    kiyakuClick() {
      this.kiyakuView = true;
    },
    messageEventHandler(event) {
      // 通知元が同じサイトでない場合はメッセージを破棄
      if (event.origin !== window.origin) {
        return;
      }

      // メッセージ内容確認
      switch (event.data) {
        // トライアル移行フラグを受け取る
        case 'trialMigration': {
          this.trialMigrationFlag = true;
          break;
        }
        default:
          break;
      }
    },
  },
};
</script>
